import { template as template_ac20edd9e8734a07b51064c9bb535408 } from "@ember/template-compiler";
import { fn, hash } from '@ember/helper';
import { on } from '@ember/modifier';
import { and, eq } from 'ember-truth-helpers';
const onShown = (tabBecameActive, { target })=>{
    tabBecameActive(target.hash.replace('#tab-', ''));
};
const Tab = template_ac20edd9e8734a07b51064c9bb535408(`
<li
  class="eflex-tab nav-item"
  {{on 'shown.bs.tab' (fn onShown @tabBecameActive)}}
  ...attributes
>
  <a
    href="#tab-{{@href}}"
    data-bs-toggle={{unless @disabled "tab"}}
    class="nav-link {{if (and @href (eq @href @activeTab)) "active"}} {{if @disabled "disabled"}}"
  >
    {{yield}}
  </a>
</li>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
const Navigation = template_ac20edd9e8734a07b51064c9bb535408(`
<ul class="nav eflex-tabs px-3" ...attributes>
  {{yield
    (hash
      tab=(component
        Tab
        tabBecameActive=@tabBecameActive
        activeTab=@activeTab
      )
    )
  }}
</ul>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
const Pane = template_ac20edd9e8734a07b51064c9bb535408(`
{{#let (eq @activeTab @id) as |isActive|}}
  <div
    id="pane-{{@id}}"
    class="{{if isActive "active"}} tab-pane"
    ...attributes
  >
    {{#if isActive}}
      {{yield}}
    {{/if}}
  </div>
{{/let}}
`, {
    eval () {
        return eval(arguments[0]);
    }
});
const Panes = template_ac20edd9e8734a07b51064c9bb535408(`
<div class="tab-content flex-fill overflow-hidden" ...attributes>
  {{yield (hash pane=(component Pane activeTab=@activeTab))}}
</div>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export default template_ac20edd9e8734a07b51064c9bb535408(`
{{yield
  (hash
    navigation=(component
      Navigation
      tabBecameActive=@tabBecameActive
      activeTab=@activeTab
    )
    panes=(component Panes activeTab=@activeTab)
  )
}}
`, {
    eval () {
        return eval(arguments[0]);
    }
});
